import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { post } from '@/api/client';
import { Button } from '@/components/atoms/Button';
import { Input } from '@/components/atoms/Input';
import { Textarea } from '@/components/atoms/Textarea';
import { toast } from '@/store/toastStore';

export function SupportPage() {
  const [form, setForm] = useState({ category: 'general', title: '', content: '' });

  const mutation = useMutation({
    mutationFn: () => post('/support', form),
    onSuccess: () => {
      toast.success('문의가 접수되었어요. 답변은 알림으로 전달돼요.');
      setForm({ category: 'general', title: '', content: '' });
    },
  });

  return (
    <div className="mx-auto max-w-xl px-5 py-6">
      <h1 className="mb-6 text-2xl font-extrabold">문의하기</h1>

      <div className="space-y-4">
        <div>
          <label className="mb-1.5 block text-sm font-medium">카테고리</label>
          <select
            value={form.category}
            onChange={(e) => setForm({ ...form, category: e.target.value })}
            className="h-10 w-full rounded-lg border border-[var(--color-border)] bg-[var(--color-surface)] px-3 text-sm"
          >
            <option value="general">일반 문의</option>
            <option value="bug">버그 신고</option>
            <option value="exchange">교환/결제</option>
            <option value="account">계정/로그인</option>
            <option value="suggestion">건의사항</option>
          </select>
        </div>
        <div>
          <label className="mb-1.5 block text-sm font-medium">제목</label>
          <Input
            value={form.title}
            onChange={(e) => setForm({ ...form, title: e.target.value })}
            maxLength={100}
          />
        </div>
        <div>
          <label className="mb-1.5 block text-sm font-medium">내용</label>
          <Textarea
            value={form.content}
            onChange={(e) => setForm({ ...form, content: e.target.value })}
            rows={8}
            maxLength={2000}
            className="w-full rounded-lg border border-[var(--color-border)] bg-[var(--color-surface)] p-3 text-sm focus:outline-none focus:ring-2 focus:ring-[var(--color-primary)]/40"
            placeholder="문의 내용을 자세히 적어주세요"
          />
        </div>
      </div>

      <Button
        fullWidth
        size="lg"
        className="mt-6"
        onClick={() => mutation.mutate()}
        loading={mutation.isPending}
        disabled={form.title.length < 2 || form.content.length < 10}
      >
        문의 접수
      </Button>

      <p className="mt-6 text-center text-xs text-[var(--color-text-sub)]">
        평균 답변 시간: 24시간 이내 · 주말/공휴일 제외
      </p>
    </div>
  );
}
